<template>
  <div class="animated fadeIn">
    <div class="row align-items-center h-100 mb-15">
      <div class="col-md-6">
        <a @click="openPage('/memberData/detail?id=' + $route.query.member + '&id_lead=' + $route.query.id_lead)" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
      <div class="col-md-6 text-right">
      </div>
    </div>
    <div class="bg-white p-20 mb-20">
      <h3 class="mb-0 text-uppercase">{{member_name}}</h3>
      <hr class="short-line left mb-15 mt-5">
      <div class="row">
        <div class="col-sm-6">
          <div class="row mb-15">
            <div class="col-sm-3">
              <div class="font-500">Total Score</div>
            </div>
            <div class="col-sm-9">
              {{total_score}}/150
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="font-500">Overall Score</div>
            </div>
            <div class="col-sm-9">
              {{overall_score}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-tab-pha">
      <b-tabs content-class="mt-3">
        <b-tab title="Step 1" id="step1_tab" active>
          <div class="mb-10 font-15">
            <span class="eng-v font-500">PAR-Q (Please see attached PAR-Q for questions)</span> /
            <span class="ind-v text-italic">PAR-Q (terlampir PAR-Q untuk pertanyaan)</span>
          </div>
          <div class="bg-white p-20">
            <div class="mb-15">
              <div v-b-toggle.step1_healthhistory class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Health History Questions</div>
                    <div class="ind-v title">[ID] Pertanyaan Riwayat Kesehatan</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step1.health_history.total_score">{{add_data.step1.health_history.total_score ? add_data.step1.health_history.total_score : 0}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step1_healthhistory" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step1.health_history : '')" :key="index">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah dokter pernah katakan anda mempunyai kondisi jantung dan hanya boleh melakukan aktifitas fisik yang di rekomendasi dokter?</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa ada rasa sakit di dada ketika melakukan aktifitas fisik?</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Di beberapa bulan terakhir, apa ada rasa sakit di dada ketika tidak sedang melakukan aktifitas fisik?</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apa anda kehilangan keseimbangan karena merasa pusing atau pernah hilang kesadaran?</div></template>
                  <template v-if="index == 'q5'"><div class="ind-v">Apa anda punya masalah dengan tulang atau sendi yang bisa memburuk dengan adanya perubahan di aktifitas fisik?</div></template>
                  <template v-if="index == 'q6'"><div class="ind-v">Apa dokter anda sedang memberikan pengobatan untuk tekanan darah atau kondisi jantung?</div></template>
                  <template v-if="index == 'q7'"><div class="ind-v">Apa ada alasan lain untuk tidak melakukan aktifitas fisik?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step1_healthhistory_'+index+'_score'"
                    v-model="add_data.step1.health_history[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Ya</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">No</div></template>
                        </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control" :name="'step1_healthhistory_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step1.health_history[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(1, 'health_history')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step1_occupational class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Occupational Questions</div>
                    <div class="ind-v title">[ID] Pertanyaan Pekerjaan</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step1.occupational.total_score">{{add_data.step1.occupational.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step1_occupational" class="box-content-pha">
                <div class="mb-20">
                  <div class="eng-v">What is your current occupation?</div>
                  <div class="ind-v">Apa pekerjaan anda saat ini? {{add_data.step1.occupational.current_occupation}}</div>
                  <b-form-input class="mt-10" v-model="add_data.step1.occupational.current_occupation" type="text"></b-form-input>
                </div>
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step1.occupational : '')" :key="index">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa pekerjaan anda mengharuskan anda duduk untuk jangka waktu yang lama?</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa pekerjaan anda mengharuskan anda melakukan gerakan yang berulang? (Jika ya, tolong jelaskan)</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apa pekerjaan anda mengharuskan anda untuk memakai sepatu hak tinggi?</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apa perkerjaan anda membuat anda stress secara mental?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step1_occupational_'+index+'_score'"
                    v-model="add_data.step1.occupational[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step1_occupational_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step1.occupational[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(1, 'occupational')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step1_recreational class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Recreational Questions</div>
                    <div class="ind-v title">[ID] Pertanyaan Rekreasional</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step1.recreational.total_score">{{add_data.step1.recreational.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step1_recreational" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step1.recreational : '')" :key="index">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah anda melakukan kegiatan rekreasional (golf, tennis, ski, etc)? (Jika ya, tolong jelaskan)</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa anda mempunyai hobby? (membaca, berkebun, mengurus mobil, internet, etc)? (Jika ya, tolong jelaskan)</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step1_recreational_'+index+'_score'"
                    v-model="add_data.step1.recreational[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step1_recreational_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step1.recreational[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(1, 'recreational')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step1_medical  class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Medical Questions</div>
                    <div class="ind-v title">[ID] Pertanyaan Kesehatan</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step1.medical.total_score">{{add_data.step1.medical.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step1_medical" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step1.medical : '')" :key="index">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa anda pernah mengalami cidera (pergelangan kaki, lutut, hip, punggung, bahu, etc)? (Jika ya, tolong jelaskan)</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa anda pernah operasi? (Jika ya, tolong jelaskan)</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apa dokter pernah mendiagnosa anda dengan penyakit kronis, seperti penyakit jantung coroner, penyakit arteri coroner, hipertensi, kolesterol tinggi atau diabetes)? (Jika ya, tolong jelaskan)</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apa anda sedang meminum obat-obatan? (Jika ya, tolong jelaskan)</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step1_medical_'+index+'_score'"
                    v-model="add_data.step1.medical[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem+'s'" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step1_medical_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step1.medical[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(1, 'medical')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-tab>
        <b-tab title="Step 2" id="step2_tab">
          <div class="mb-10 font-15">
            <span class="eng-v font-500">Behavioral Habits</span> /
            <span class="ind-v text-italic">Kebiasaan Perilaku</span>
          </div>
          <div class="bg-white p-20">
            <div class="mb-15">
              <div v-b-toggle.step2_alcohol class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Alcohol</div>
                    <div class="ind-v title">[ID] Alkohol</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step2.alcohol.total_score">{{add_data.step2.alcohol.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step2_alcohol" class="box-content-pha">
                <!-- <div>
                  {{add_data.step2.alcohol.q1.score}}
                </div> -->
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step2.alcohol : '')" :key="index + '11'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Seberapa sering mengkonsumsi alkohol?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step2_alcohol_'+index+'_score'"
                    v-model="add_data.step2.alcohol[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio class="font-13" :id="indexitem + 'reCreate'" :key="indexitem + 'reCreate'" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">&gt;2 kali dalam seminggu</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">1 x seminggu</div></template>
                        <template v-if="indexitem == 'a3'"><div class="ind-v">1-2 kali dalam sebulan</div></template>
                        <template v-if="indexitem == 'a4'"><div class="ind-v">Hanya dalam acara khusus</div></template>
                        <template v-if="indexitem == 'a5'"><div class="ind-v">Tidak pernah</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step2_alcohol_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step2.alcohol[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(2, 'alcohol')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step2_smoking class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Smoking</div>
                    <div class="ind-v title">[ID] Merokok</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step2.smoking.total_score">{{add_data.step2.smoking.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step2_smoking" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step2.smoking : 0)" :key="index+'13'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa anda merokok?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step2_smoking_'+index+'_score'"
                    v-model="add_data.step2.smoking[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio class="font-13" :key="indexitem + 'smoking'" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Setiap hari</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">Hanya perokok sosial</div></template>
                        <template v-if="indexitem == 'a3'"><div class="ind-v">Hanya dalam acara khusus</div></template>
                        <template v-if="indexitem == 'a4'"><div class="ind-v">Tidak pernah</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step2_smoking_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step2.smoking[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(2, 'smoking')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step2_nutrition class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Nutrition</div>
                    <div class="ind-v title">[ID] Nutrisi</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step2.nutrition.total_score">{{add_data.step2.nutrition.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step2_nutrition" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step2.nutrition : '')" :key="index+'12'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa anda sering mencoba berbagai macam diet dengan hasil yang sedikit?</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa anda mengikuti rencana nutrisi yang seimbang dan anda merasa mengerti kebiasaan nutrisi anda?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step2_nutrition_'+index+'_score'"
                    v-model="add_data.step2.nutrition[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="index == 'q1' && indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="index == 'q1' && indexitem == 'a2'"><div class="ind-v">N</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a2'"><div class="ind-v">No</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a3'"><div class="ind-v">Tidak Yakin</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step2_nutrition_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step2.nutrition[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(2, 'nutrition')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step2_stress class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Stress</div>
                    <div class="ind-v title">[ID] Stress</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step2.stress.total_score">{{add_data.step2.stress.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step2_stress" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step2.stress : '')" :key="index+'14'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa anda menderita stress kronis?</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apa anda merasa terkadang stress itu menantang dan bermanfaat?</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step2_stress_'+index+'_score'"
                    v-model="add_data.step2.stress[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="index == 'q1' && indexitem == 'a1'"><div class="ind-v">Setiap hari</div></template>
                        <template v-if="index == 'q1' && indexitem == 'a2'"><div class="ind-v">Setiap minggu</div></template>
                        <template v-if="index == 'q1' && indexitem == 'a3'"><div class="ind-v">Kadang-kadang</div></template>
                        <template v-if="index == 'q1' && indexitem == 'a4'"><div class="ind-v">Jarang</div></template>
                        <template v-if="index == 'q1' && indexitem == 'a5'"><div class="ind-v">Tidak pernah</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a1'"><div class="ind-v">Yes</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a2'"><div class="ind-v">No</div></template>
                        <template v-if="index == 'q2' && indexitem == 'a3'"><div class="ind-v">Tidak Yakin</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step2_stress_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step2.stress[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(2, 'stress')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step2_sleep class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Sleep</div>
                    <div class="ind-v title">[ID] Tidur</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step2.sleep.total_score">{{add_data.step2.sleep.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step2_sleep" class="box-content-pha">
                <div class="mb-20" v-for="(item, index) in (scoresheet ? scoresheet.step2.sleep : '')" :key="index+'15'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apa anda biasanya tidur dengan baik</div></template>
                  <b-form-radio-group class="radio-custom-list mt-10" :name="'step2_sleep_'+index+'_score'"
                    v-model="add_data.step2.sleep[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio class="font-13" :key="indexitem+'data'" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">&gt;7.5 jam tiap malam</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">6.5-7.5 jam tiap malam</div></template>
                        <template v-if="indexitem == 'a3'"><div class="ind-v">6-6.5 jam tiap malam</div></template>
                        <template v-if="indexitem == 'a4'"><div class="ind-v">5-6 jam tiap malam</div></template>
                        <template v-if="indexitem == 'a5'"><div class="ind-v">&lt;5-6 jam tiap malam</div></template>
                        <template v-if="indexitem == 'a6'"><div class="ind-v">Pola tidur saya tidak teratur</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <textarea class="form-control mt-10" :name="'step2_sleep_'+index+'_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step2.sleep[index].notes"></textarea>
                </div>
                <div class="text-right">
                  <button @click="submitStep(2, 'sleep')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-tab>
        <b-tab title="Step 3" id="step3_tab">
          <div class="mb-10 font-15">
            <span class="eng-v font-500">Metabolic Information</span> /
            <span class="ind-v">Informasi Metabolisme</span>
          </div>
          <div class="bg-white p-20">
            <div class="mb-15">
              <div v-b-toggle.step3_blood_pressure_chart class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Blood Pressure</div>
                    <div class="ind-v title">[ID] Tekanan Darah</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step3.blood_pressure_chart.score">{{add_data.step3.blood_pressure_chart.score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step3_blood_pressure_chart" class="box-content-pha">
                <div class="mb-10">Blood Pressure Chart</div>
                <div><img src="/img/bloodpressure.png"/></div>
                <div class="mb-5">Systolic Pressure {{add_data.step3.blood_pressure_chart ? add_data.step3.blood_pressure_chart : ''}}</div>
                <b-form-input class="mb-20" v-model="add_data.step3.blood_pressure_chart.systolic" type="text" @change="calculateBloodPressure"></b-form-input>
                <div class="mb-5">Diastolic Pressure</div>
                <b-form-input class="mb-20" v-model="add_data.step3.blood_pressure_chart.diastolic" type="text" @change="calculateBloodPressure"></b-form-input>
                <div class="mb-5">Blood Pressure Level</div>
                <b-form-input class="mb-20" type="text" id="blood_pressure_calc" v-model="calc.blood_pressure" disabled></b-form-input>
                <div class="mb-5">Blood Pressure Range</div>
                <b-form-select name="step3_blood_pressure_chart_select" v-model="add_data.step3.blood_pressure_chart.score" class="form-control mb-20">
                  <option value="null" selected>Please select</option>
                  <template v-for="(item, index) in (scoresheet ? scoresheet.step3.blood_pressure.blood_pressure_chart : '')">
                    <option :key="index" :value="item.score">
                      {{item.label}}
                      <template v-if="index == 'o1'">(Rendah)</template>
                      <template v-if="index == 'o2'">(Normal)</template>
                      <template v-if="index == 'o3'">(Agak Tinggi)</template>
                      <template v-if="index == 'o4'">(Tinggi)</template>
                    </option>
                  </template>
                </b-form-select>
                <div class="mb-10">Scoring</div>
                <b-form-input class="mb-20" disabled v-model="add_data.step3.blood_pressure_chart.score" type="text"></b-form-input>
                <div class="text-right">
                  <button @click="submitStep(3, 'blood_pressure_chart')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step3_blood_bpd class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Bolt BPD</div>
                    <div class="ind-v title">[ID] Bolt BPD</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step3.blood_bpd.score">{{add_data.step3.blood_bpd.score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step3_blood_bpd" class="box-content-pha">
                <div class="mb-10">
                  Bolt BPD Time
                </div>
                <b-form-input class="mb-20" v-model="add_data.step3.blood_bpd.value" type="text"></b-form-input>
                <div class="mb-10">
                  Bolt BPD Range
                </div>
                <b-form-select name="step3_blood_bpd_select" v-model="add_data.step3.blood_bpd.score" class="form-control mb-20">
                  <option value="null" selected>Please select</option>
                  <template v-for="(item, index) in (scoresheet ? scoresheet.step3.blood_pressure.blood_bpd : '')">
                    <option :key="index+'blood2'" :value="item.score">{{item.label}}</option>
                  </template>
                </b-form-select>
                <div class="mb-10">Scoring</div>
                <b-form-input class="mb-20" disabled v-model="add_data.step3.blood_bpd.score" type="text"></b-form-input>
                <div class="text-right">
                  <button @click="submitStep(3, 'blood_bpd')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step3_body_composition class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">[EN] Body Composition</div>
                    <div class="ind-v title">[ID] Komposisi Badan</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step3.body_composition.total_score">{{add_data.step3.body_composition.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step3_body_composition" class="box-content-pha">
                <div class="main-title">
                  <span class="eng-v">Client/Member Statistic</span> /
                  <span class="ind-v">Statistik Klien/Member</span>
                </div>
                <hr class="short-line left mb-15 mt-5">
                <div class="b-part">
                  <div class="mb-15">
                    <div class="mb-10">Gender</div>
                    <b-form-radio-group class="radio-custom-list" name="step3_gender"
                    v-model="add_data.step3.gender">
                      <b-form-radio class="font-13" value="Male">Male</b-form-radio>
                      <b-form-radio class="font-13" value="Female">Female</b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <div class="mb-15">
                    <div class="eng-v">Age</div>
                    <div class="ind-v">Umur</div>
                    <b-form-input class="mt-10" v-validate="'numeric'" name="step3_age" v-model="add_data.step3.age" type="number" min="0" @change="calculateMetabolicAgeDiff"></b-form-input>
                    <span class="error">{{ errors.first('step3_age') }}</span>
                  </div>
                  <div class="mb-15">
                    <div class="eng-v">Height</div>
                    <div class="ind-v">Tinggi</div>
                    <b-form-input class="mt-10" v-validate="'decimal'" name="step3_height" v-model="add_data.step3.height" type="text" min="0" @change="calculateHeightWaistRatio"></b-form-input>
                    <span class="error">{{ errors.first('step3_height') }}</span>
                  </div>
                  <div class="mb-15">
                    <div class="eng-v">Waist</div>
                    <div class="ind-v">Pinggang</div>
                    <b-form-input class="mt-10" v-validate="'decimal'" name="waist" v-model="add_data.step3.waist" type="text" min="0" @change="calculateHeightWaistRatio"></b-form-input>
                    <span class="error">{{ errors.first('waist') }}</span>
                  </div>
                  <div class="mb-15">
                    <div class="eng-v">Weight</div>
                    <div class="ind-v">Berat badan</div>
                    <b-form-input class="mt-10" v-validate="'decimal'" name="weight" v-model="add_data.step3.weight" type="text" min="0" @change="calculateBoneMassPercent(); calculateVo2max();"></b-form-input>
                    <span class="error">{{ errors.first('weight') }}</span>
                  </div>
                </div>
                <template v-if="add_data.step3.gender">
                  <div class="main-title">Body Fat</div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="b-part">
                    <div class="mb-10">Body Fat %</div>
                    <b-form-input class="mb-20" v-model="add_data.step3.body_composition.body_fat.value" type="text"></b-form-input>
                    <div class="mb-10">Body Fat % Range</div>
                    <b-form-select name="step3_body_fat_select" v-model="add_data.step3.body_composition.body_fat.score" class="form-control mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet && add_data.step3.gender ? scoresheet.step3.body_composition.body_fat[add_data.step3.gender.toLowerCase()][(add_data.step3.age<40 ? 'under40' : 'over40')] : '')">
                        <option :key="index+'body_fat'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                    <div class="mb-10">
                    Scoring
                    </div>
                    <b-form-input class="mb-20" disabled v-model="add_data.step3.body_composition.body_fat.score" type="text"></b-form-input>
                  </div>
                  <div class="main-title">
                    <span class="eng-v">Bone Mass</span> /
                    <span class="ind-v">Masa Tulang</span>
                  </div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="b-part">
                    <div class="eng-v">Bone Mass</div>
                    <div class="ind-v">Masa Tulang</div>
                    <div class="mt-10 mb-20">
                      <b-form-input v-validate="'decimal'" name="body_composition_bone_mass" v-model="add_data.step3.body_composition.bone_mass.value" @change="calculateBoneMassPercent"></b-form-input>
                      <span class="error">{{ errors.first('body_composition_bone_mass') }}</span>
                    </div>
                    <div class="eng-v">Bone Mass Percentage</div>
                    <div class="ind-v">Persentase Masa Tulang</div>
                    <b-form-input class="mt-10 mb-20" type="text" id="bone_mass_percent_calc" v-model="calc.bone_mass_percent" disabled></b-form-input>
                    <div class="eng-v">Bone Mass Range</div>
                    <div class="ind-v">Kisaran Masa Tulang</div>
                    <b-form-select name="step3_bone_mass_select" v-model="add_data.step3.body_composition.bone_mass.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet ? scoresheet.step3.body_composition.bone_mass[add_data.step3.gender.toLowerCase()] : '')">
                        <option :key="index+'bonemass'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                    Scoring <b-form-input class="mt-10 mb-20" disabled v-model="add_data.step3.body_composition.bone_mass.score" type="text"></b-form-input>
                  </div>
                  <div class="main-title">Visceral Fat</div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="b-part">
                    Visceral Fat <b-form-input class="mt-10 mb-20" v-model="add_data.step3.body_composition.visceral_fat.value" type="text"></b-form-input>
                    Visceral Fat Range <b-form-select name="step3_visceral_fat_select" v-model="add_data.step3.body_composition.visceral_fat.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet ? scoresheet.step3.body_composition.visceral_fat : '')">
                        <option :key="index+'visceral_fat'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                    Scoring <b-form-input class="mt-10 mb-20" disabled v-model="add_data.step3.body_composition.visceral_fat.score" type="text"></b-form-input>
                  </div>
                  <div class="main-title">Metabolic Body Age</div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="b-part">
                    Metabolic Body Age <b-form-input class="mt-10 mb-20" type="number" v-model="add_data.step3.body_composition.metabolic_body_age.value" @change="calculateMetabolicAgeDiff"></b-form-input>
                    Metabolic Age Difference <b-form-input class="mt-10 mb-20" type="text" id="metabolic_body_age_calc" v-model="calc.metabolic_body_age" disabled></b-form-input>
                    Metabolic Body Age Range <b-form-select name="step3_metabolic_body_age_select" v-model="add_data.step3.body_composition.metabolic_body_age.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet ? scoresheet.step3.body_composition.metabolic_body_age : '')">
                        <option :key="index+'metabolic_body_age'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                    Scoring <b-form-input class="mt-10 mb-20" disabled v-model="add_data.step3.body_composition.metabolic_body_age.score" type="text"></b-form-input>
                  </div>
                  <div class="main-title">BMI</div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="b-part">
                    BMI <b-form-input class="mt-10 mb-20" v-model="add_data.step3.bmi" type="text"></b-form-input>
                    <div>
                      <div class="end-v">Height to Waist Ratio</div>
                      <div class="ind-v">Height to Waist Rasio</div>
                    </div>
                    <b-form-input type="text" class="mt-10 mb-20" id="height_waist_ratio_calc" v-model="calc.height_waist_ratio" disabled></b-form-input>
                    <div class="end-v">Height to Waist Ratio</div>
                    <div class="ind-v">Height to Waist Rasio</div>
                    <b-form-select name="step3_height_waist_ratio_select" v-model="add_data.step3.body_composition.height_waist_ratio.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet ? scoresheet.step3.body_composition.height_waist_ratio : '')">
                        <option :key="index+'body_composition'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                    Scoring <b-form-input class="mt-10 mb-20" disabled v-model="add_data.step3.body_composition.height_waist_ratio.score" type="text"></b-form-input>
                  </div>
                </template>
                <div class="text-right">
                  <button @click="submitStep(3, 'body_composition')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-tab>
        <b-tab title="Step 4" id="step4_tab">
          <div class="mb-10 font-15">
            <span class="eng-v font-500">Assessment</span> /
            <span class="ind-v">Penilaian</span>
          </div>
          <div class="bg-white p-20">
            <div class="mb-15">
              <div v-b-toggle.step4_grid_postural_analysis class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">Grid Postural Analysis / Analisis Grid Postural</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step4.grid_postural_analysis.total_score">{{add_data.step4.grid_postural_analysis.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step4_grid_postural_analysis" class="box-content-pha">
                <div class="mb-10">Upload Image</div>
                <div class="row mb-20">
                  <div class="col-sm-3">
                    <div class="custom-upload-img">
                      <div class="circle-center">
                        <div class="d-flex align-items-center h-100 justify-content-center">
                          <i class="icon-camera"></i>
                        </div>
                      </div>
                      <b-form-file name="step4_img1" @change="previewImage1" accept="image/*"
                        v-model="add_data.step4.grid_postural_analysis.img1"
                        :state="Boolean(add_data.step4.grid_postural_analysis.img1)" plain></b-form-file>
                      <div class="image-preview" v-if="image_data1.length > 0">
                          <img class="preview w-100 img-fix img-profie" :src="image_data1">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="custom-upload-img">
                      <div class="circle-center">
                        <div class="d-flex align-items-center h-100 justify-content-center">
                          <i class="icon-camera"></i>
                        </div>
                      </div>
                      <b-form-file name="step4_img2" @change="previewImage2" accept="image/*"
                        v-model="add_data.step4.grid_postural_analysis.img2"
                        :state="Boolean(add_data.step4.grid_postural_analysis.img2)" plain></b-form-file>
                      <div class="image-preview" v-if="image_data2.length > 0">
                          <img class="preview w-100 img-fix img-profie" :src="image_data2">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="custom-upload-img">
                      <div class="circle-center">
                        <div class="d-flex align-items-center h-100 justify-content-center">
                          <i class="icon-camera"></i>
                        </div>
                      </div>
                      <b-form-file name="step4_img3" @change="previewImage3" accept="image/*"
                        v-model="add_data.step4.grid_postural_analysis.img3"
                        :state="Boolean(add_data.step4.grid_postural_analysis.img3)" plain></b-form-file>
                      <div class="image-preview" v-if="image_data3.length > 0">
                          <img class="preview w-100 img-fix img-profie" :src="image_data3">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main-title">
                  <span class="eng-v">Front View Analysis</span> /
                  <span class="ind-v">Analisis Sisi Depan</span>
                </div>
                <hr class="short-line left mb-15 mt-5">
                <div v-for="(item, index) in (scoresheet ? scoresheet.step4.front_view_analysis : '')" :key="index+'front_view_analysis'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah kaki nya simetri</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apakah tangannya rotasi internal secara simetri</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apakah acromion processes nya sejajar (bahu naik)</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apakah hidung sejajar dengan plumb line</div></template>
                  <template v-if="index == 'q5'"><div class="ind-v">Apakah kedua telinga terlihat (rotasi kepala)</div></template>
                  <b-form-radio-group class="radio-custom-list" :name="'step4_front_view_analysis_'+index+'_score'"
                    v-model="add_data.step4.grid_postural_analysis.front_view_analysis[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                </div>
                <div class="main-title">
                  <span class="eng-v">Side View Analysis</span> /
                  <span class="ind-v">Analisis sisi samping</span>
                </div>
                <hr class="short-line left mb-15 mt-5">
                <div v-for="(item, index) in (scoresheet ? scoresheet.step4.side_view_analysis : '')" :key="index+'side_view_analysis'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah tibia sejajar dengan plumb line</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apakah anterior atau posterior pelvic tilt dapat diterima</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apakah greater trochanter sejajar dengan plumb line</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apakah acromion process sejajar dengan plumb line</div></template>
                  <template v-if="index == 'q5'"><div class="ind-v">Apakah auditory meatus (lubang telinga) sejajar dengan plumb line</div></template>
                  <b-form-radio-group class="radio-custom-list" :name="'step4_side_view_analysis_'+index+'_score'"
                    v-model="add_data.step4.grid_postural_analysis.side_view_analysis[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem+'answer'" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                </div>
                <div class="text-right">
                  <button @click="submitStep(4, 'grid_postural_analysis')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step4_trx_map class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">Trx Maps</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step4.trx_map.score">{{add_data.step4.trx_map.score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step4_trx_map" class="box-content-pha">
                Trx Maps %
                <b-form-input class="mt-10 mb-20" v-model="add_data.step4.trx_map.value" type="text"></b-form-input>
                Trx Maps % Range
                <b-form-select name="step4_trx_map_select" v-model="add_data.step4.trx_map.score" class="form-control mt-10 mb-20">
                  <option value="null" selected>Please select</option>
                  <option v-for="(item, index) in (scoresheet ? scoresheet.step4.trx_map : '')" :key="index+'trx_map'" :value="item.score">{{item.label}}</option>
                </b-form-select>
                <div class="text-right">
                  <button @click="submitStep(4, 'trx_map')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step4_oc_cc class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">OC-CC</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step4.oc_cc.total_score">{{add_data.step4.oc_cc.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step4_oc_cc" class="box-content-pha">
                <div>
                  <span class="eng-v">OC Test</span> /
                  <span class="ind-v">Tes OC</span>
                </div>
                <hr class="short-line left mb-15 mt-5">
                <div v-for="(item, index) in (scoresheet ? scoresheet.step4.oc_test : '')" :key="index+'oc_test'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah sendi hip nya simetri</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apakah rotasi external atau internal hipnya dapat diterima?</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apakah Panjang kakinya sama</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apakah ada pergerakan subtalar yang memadai dan seimbang</div></template>
                  <template v-if="index == 'q5'"><div class="ind-v">Apakah kedua pergelangan kaki punya dorsi flexion sebesar 5 derajat</div></template>
                  <b-form-radio-group class="radio-custom-list " :name="'step4_oc_test_'+index+'_score'"
                    v-model="add_data.step4.oc_cc.oc_test[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem+'oc_test'" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                </div>
                <div>
                  <span class="eng-v">CC Test</span> /
                  <span class="ind-v">Tes CC</span>
                </div>
                <hr class="short-line left mb-15 mt-5">
                <div v-for="(item, index) in (scoresheet ? scoresheet.step4.cc_test : '')" :key="index+ 'dataNew'">
                  <div class="eng-v">{{item.question}}</div>
                  <template v-if="index == 'q1'"><div class="ind-v">Apakah Subtalar joint simetri di kedua sisi</div></template>
                  <template v-if="index == 'q2'"><div class="ind-v">Apakah ST Joint netral di kedua sisi</div></template>
                  <template v-if="index == 'q3'"><div class="ind-v">Apakah glute med dan kaki nya aktif untuk membawa ST joint menjadi netral di kedua sisi</div></template>
                  <template v-if="index == 'q4'"><div class="ind-v">Apakah otot “Inverter” bekerja di kedua sisi</div></template>
                  <template v-if="index == 'q5'"><div class="ind-v">Apakah inversi ST Joint simetri di kedua sisi</div></template>
                  <b-form-radio-group class="radio-custom-list" :name="'step4_cc_test_'+index+'_score'"
                    v-model="add_data.step4.oc_cc.cc_test[index].score">
                    <template v-for="(items, indexitem) in item.answer">
                      <b-form-radio :key="indexitem+'oc_cc'" class="font-13" :value="items.score">
                        <div class="eng-v">{{items.label}}</div>
                        <template v-if="indexitem == 'a1'"><div class="ind-v">Y</div></template>
                        <template v-if="indexitem == 'a2'"><div class="ind-v">N</div></template>
                      </b-form-radio>
                    </template>
                  </b-form-radio-group>
                </div>
                <div class="text-right">
                  <button @click="submitStep(4, 'oc_cc')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step4_screening class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">Screening</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step4.screening.total_score">{{add_data.step4.screening.total_score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step4_screening" class="box-content-pha">
                Deep Squat
                <b-form-radio-group class="radio-custom-list" name="step4_screening_deepsquat"
                  v-model.number="add_data.step4.screening.deep_squat.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_deep_squat_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.deep_squat.notes"></textarea>
                Hurdle Step <b-form-radio-group class="radio-custom-list" name="step4_screening_hurdlestep"
                  v-model.number="add_data.step4.screening.hurdle_step.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_hurdle_step_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.hurdle_step.notes"></textarea>
                Inline Lunge <b-form-radio-group class="radio-custom-list" name="step4_screening_inlinelunge"
                  v-model.number="add_data.step4.screening.inline_lunge.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_inline_lunge_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.inline_lunge.notes"></textarea>
                Shoulder Mobility (Don't forget shoulder impingement clearing test) <b-form-radio-group class="radio-custom-list" name="step4_screening_shouldermobility"
                  v-model.number="add_data.step4.screening.shoulder_mobility.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_shoulder_mobility_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.shoulder_mobility.notes"></textarea>
                Active Straight-Leg Raise <b-form-radio-group class="radio-custom-list" name="step4_screening_activestraightlegraise"
                  v-model.number="add_data.step4.screening.active_straight_leg_raise.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_active_straight_leg_raise_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.active_straight_leg_raise.notes"></textarea>
                Trunk Stability Push Up (Don't forget spinal extention clearing test) <b-form-radio-group class="radio-custom-list" name="step4_screening_trunkstabilitypushup"
                  v-model.number="add_data.step4.screening.trunk_stability_push_up.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_trunk_stability_push_up_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.trunk_stability_push_up.notes"></textarea>
                Rotary Torso (Don't forget child pose clearing test) <b-form-radio-group class="radio-custom-list" name="step4_screening_rotarytorso"
                  v-model.number="add_data.step4.screening.rotary_torso.score">
                    <b-form-radio class="font-13" value="0">0</b-form-radio>
                    <b-form-radio class="font-13" value="1">1</b-form-radio>
                    <b-form-radio class="font-13" value="2">2</b-form-radio>
                    <b-form-radio class="font-13" value="3">3</b-form-radio>
                </b-form-radio-group>
                <textarea class="form-control mb-20" :name="'step4_screening_rotary_torso_notes'" rows="3" placeholder="Notes (Catatan)"
                    v-model="add_data.step4.screening.rotary_torso.notes"></textarea>
                <div class="text-right">
                  <button @click="submitStep(4, 'screening')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
            <div class="mb-15">
              <div v-b-toggle.step4_physical class="btn-collapse">
                <div class="row h-100 align-items-center">
                  <div class="col-md-6">
                    <div class="eng-v title">Physical Test</div>
                  </div>
                  <div class="col-md-6 text-right">
                    <span class="box-score" v-if="add_data.step4.physical.score">{{add_data.step4.physical.score}}</span>
                  </div>
                </div>
              </div>
              <b-collapse id="step4_physical" class="box-content-pha">
                <div>
                  Default
                  <b-form-radio-group class="radio-custom-list mt-10" name="step4_physical_default"
                  v-model="add_data.step4.physical.default">
                    <b-form-radio class="font-13" value="vo2_max">VO2 Max</b-form-radio>
                    <b-form-radio class="font-13" value="strength">
                      <div class="eng-v">Strength</div>
                      <div class="ind-v">Kekuatan</div>
                    </b-form-radio>
                    <b-form-radio class="font-13" value="agility">
                      <div class="eng-v">Agility</div>
                      <div class="ind-v">Ketangkasan</div>
                    </b-form-radio>
                </b-form-radio-group>
                </div>
                <div>
                  <div>VO2 Max</div>
                  <hr class="short-line left mb-15 mt-5">
                  Average Watts
                  <b-form-input class="mt-10 mb-20" v-model="add_data.step4.physical.vo2_max.value" type="text" @change="calculateVo2max"></b-form-input>
                  VO2 Max
                  <b-form-input class="mt-10 mb-20" type="text" id="voa2max_calc" v-model="calc.vo2max" disabled></b-form-input>
                  <template v-if="add_data.step3.gender">
                    <div>VO2 Max Range</div>
                    <b-form-select name="step4_vo2_max_select" v-model="add_data.step4.physical.vo2_max.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet && add_data.step3.gender ? scoresheet.step4.vo2_max[add_data.step3.gender.toLowerCase()] : '')">
                        <option :key="index+'vo2_max'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                  </template>
                </div>
                <div>
                  <div>
                    <span class="eng-v">Strength</span> /
                    <span class="ind-v">Kekuatan</span>
                  </div>
                  <hr class="short-line left mb-15 mt-5">
                  <div class="eng-v">Hand Hold</div>
                  <div class="ind-v">Hand Holds</div>
                  <b-form-input class="mt-10 mb-20" v-model="add_data.step4.physical.strength.hand_hold.value" type="text"></b-form-input>
                  <template v-if="add_data.step3.gender">
                    <div class="eng-v">Hand Hold Range</div>
                    <div class="ind-v">Kisaran Hand Holds</div>
                    <b-form-select name="step4_strength_hand_hold_select" v-model="add_data.step4.physical.strength.hand_hold.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet && add_data.step3.gender ? scoresheet.step4.strength.hand_hold[this.add_data.step3.gender.toLowerCase()] : '')">
                        <option :key="index+'hand_hold'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                  </template>
                  <div class="eng-v">Push Up</div>
                  <div class="ind-v">Tes Push Up</div>
                  <b-form-input class="mt-10 mb-20" v-model="add_data.step4.physical.strength.push_up.value" type="text"></b-form-input>
                  <template v-if="add_data.step3.gender">
                    <div class="eng-v">Push Up Range</div>
                    <div class="ind-v">Kisaran Tes Push Up</div>
                    <b-form-select name="step4_strength_push_up_select" v-model="add_data.step4.physical.strength.push_up.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet && add_data.step3.gender ? scoresheet.step4.strength.push_up[this.add_data.step3.gender.toLowerCase()] : '')">
                        <option :key="index+'push_up'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                  </template>
                  <div class="eng-v">Bodyweight Squat</div>
                  <div class="ind-v">Tes Squat Berat Badan</div>
                  <b-form-input class="mt-10 mb-20" v-model="add_data.step4.physical.strength.bodyweight_squat.value" type="text"></b-form-input>
                  <template v-if="add_data.step3.gender">
                    <div class="eng-v">Bodyweight Squat Range</div>
                    <div class="ind-v">Kisaran Tes Squat Berat Badan</div>
                    <b-form-select name="step4_strength_bodyweight_squat_select" v-model="add_data.step4.physical.strength.bodyweight_squat.score" class="form-control mt-10 mb-20">
                      <option value="null" selected>Please select</option>
                      <template v-for="(item, index) in (scoresheet && add_data.step3.gender ? scoresheet.step4.strength.bodyweight_squat[this.add_data.step3.gender.toLowerCase()] : '')">
                        <option :key="index+'bodyweight_squat'" :value="item.score">{{item.label}}</option>
                      </template>
                    </b-form-select>
                  </template>
                </div>
                <div>
                  <div>
                    <span class="eng-v">Agility</span> /
                    <span class="ind-v">Ketangkasan</span>
                  </div>
                  <hr class="short-line left mb-15 mt-5">
                  Shark Test <b-form-input class="mt-10 mb-20" v-model="add_data.step4.physical.agility.shark_test.value" type="text"></b-form-input>
                  Shark Test Range <b-form-select name="step4_agility_shark_test_select" v-model="add_data.step4.physical.agility.shark_test.score" class="form-control mt-10 mb-20">
                    <option value="null" selected>Please select</option>
                    <template v-for="(item, index) in (scoresheet ? scoresheet.step4.agility.shark_test : '')">
                      <option :key="index+'agility'" :value="item.score">{{item.label}}</option>
                    </template>
                  </b-form-select>
                </div>
                <div class="text-right">
                  <button @click="submitStep(4, 'physical')" type="button" class="btn-primary">Submit</button>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'phaform',
  data: function () {
    return {
      member_name: '',
      scoresheet: '',
      total_score: 0,
      overall_score: '',
      image_data1: '',
      image_data2: '',
      image_data3: '',
      calc: {
        blood_pressure: '',
        bone_mass_percent: '',
        metabolic_body_age: '',
        height_waist_ratio: '',
        vo2max: '',
      },
      add_data: {
        id: '',
        member_id: '',
        step1: {
          health_history: {
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            q3: {
              score: null,
              notes: ''
            },
            q4: {
              score: null,
              notes: ''
            },
            q5: {
              score: null,
              notes: ''
            },
            q6: {
              score: null,
              notes: ''
            },
            q7: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          occupational: {
            current_occupation: '',
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            q3: {
              score: null,
              notes: ''
            },
            q4: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          recreational: {
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          medical: {
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            q3: {
              score: null,
              notes: ''
            },
            q4: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          total_score: null
        },
        step2: {
          alcohol: {
            q1: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          smoking: {
            q1: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          nutrition: {
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          stress: {
            q1: {
              score: null,
              notes: ''
            },
            q2: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          sleep: {
            q1: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          total_score: null
        },
        step3: {
          blood_pressure_chart: {
            systolic: '',
            diastolic: '',
            score: null
          },
          blood_bpd: {
            value: '',
            score: null
          },
          body_composition: {
            body_fat: {
              value: '',
              score: null
            },
            bone_mass: {
              value: '',
              score: null
            },
            visceral_fat: {
              value: '',
              score: null
            },
            metabolic_body_age: {
              value: '',
              score: null
            },
            bmi: '',
            height_waist_ratio: {
              score: null
            },
            total_score: null
          },
          gender: 'Male',
          age: 0,
          height: 0,
          weight: 0,
          waist: 0,
          total_score: null
        },
        step4: {
          grid_postural_analysis: {
            img1: null,
            img2: null,
            img3: null,
            front_view_analysis: {
              q1: { score: null },
              q2: { score: null },
              q3: { score: null },
              q4: { score: null },
              q5: { score: null },
              total_score: null
            },
            side_view_analysis: {
              q1: { score: null },
              q2: { score: null },
              q3: { score: null },
              q4: { score: null },
              q5: { score: null },
              total_score: null
            },
            total_score: null
          },
          trx_map: {
            value: '',
            score: null
          },
          oc_cc: {
            oc_test: {
              q1: { score: null },
              q2: { score: null },
              q3: { score: null },
              q4: { score: null },
              q5: { score: null },
              total_score: null
            },
            cc_test: {
              q1: { score: null },
              q2: { score: null },
              q3: { score: null },
              q4: { score: null },
              q5: { score: null },
              total_score: null
            },
            total_score: null
          },
          screening: {
            deep_squat: {
              score: null,
              notes: ''
            },
            hurdle_step: {
              score: null,
              notes: ''
            },
            inline_lunge: {
              score: null,
              notes: ''
            },
            shoulder_mobility: {
              score: null,
              notes: ''
            },
            active_straight_leg_raise: {
              score: null,
              notes: ''
            },
            trunk_stability_push_up: {
              score: null,
              notes: ''
            },
            rotary_torso: {
              score: null,
              notes: ''
            },
            total_score: null
          },
          physical: {
            default: 'vo2_max',
            vo2_max: {
              value: '',
              score: null
            },
            strength: {
              hand_hold: {
                value: '',
                score: null
              },
              push_up: {
                value: '',
                score: null
              },
              bodyweight_squat: {
                value: '',
                score: null
              },
              score: null
            },
            agility: {
              shark_test: {
                value: '',
                score: null
              },
              score: null
            },
            score: null
          },
          total_score: null
        }
      }
    }
  },
  methods: {
    loadingView () {
      this.loadingActive = false
    },
    openPage (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    editCallModal (id, event) {
      this.$refs[id].show()
      this.getActivityId = event
      // console.log(event)
      axios.get('crm/v1/leads_activities/' + event).then(response => {
        this.editCall = response.data.data
        // this.statusActivityCall(2)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    editAppointmentModal (id, event) {
      this.$refs[id].show()
      this.getActivityId = event
      // console.log(event)
      axios.get('crm/v1/leads_activities/' + event).then(response => {
        this.editAppointment = response.data.data
        // this.statusActivityAppointment(4)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    hideModal (id) {
      this.$refs[id].hide()
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    previewImage1(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image_data1 = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    previewImage2(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image_data2 = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    previewImage3(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image_data3 = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    calculateBloodPressure() {
      let calc = 0
      let temp = 0
      let sys = this.add_data.step3.blood_pressure_chart.systolic
      let dias = this.add_data.step3.blood_pressure_chart.diastolic

      if(sys >= 90 && sys < 120)
        calc = 1
      else if(sys >= 120 && sys < 140)
        calc = 2
      else if(sys >= 140)
        calc = 3

      if(dias >= 60 && dias < 80)
        temp = 1
      else if(dias >= 80 && dias < 90)
        temp = 2
      else if(dias >= 90)
        temp = 3

      if(calc < temp)
        calc = temp

      if(calc == 0)
        this.calc.blood_pressure = 'Low'
      else if(calc == 1)
        this.calc.blood_pressure = 'Normal'
      else if(calc == 2)
        this.calc.blood_pressure = 'Pre-High'
      else if(calc == 3)
        this.calc.blood_pressure = 'High'
    },
    calculateBoneMassPercent() {
      let percent = this.add_data.step3.body_composition.bone_mass.value / this.add_data.step3.weight * 100
      this.calc.bone_mass_percent = percent + '%'
    },
    calculateMetabolicAgeDiff() {
      this.calc.metabolic_body_age = this.add_data.step3.age - this.add_data.step3.body_composition.metabolic_body_age.value
    },
    calculateHeightWaistRatio() {
      this.calc.height_waist_ratio = this.add_data.step3.waist / this.add_data.step3.height
    },
    calculateVo2max() {
      this.calc.vo2max = this.add_data.step4.physical.vo2_max.value * 10.8 / this.add_data.step3.weight + 7
    },
    calculateStep1Score() {
      this.add_data.step1.health_history.total_score = this.add_data.step1.health_history.q1.score
        + this.add_data.step1.health_history.q2.score
        + this.add_data.step1.health_history.q3.score
        + this.add_data.step1.health_history.q4.score
        + this.add_data.step1.health_history.q5.score
        + this.add_data.step1.health_history.q6.score
        + this.add_data.step1.health_history.q7.score

      this.add_data.step1.occupational.total_score = this.add_data.step1.occupational.q1.score
        + this.add_data.step1.occupational.q2.score
        + this.add_data.step1.occupational.q3.score
        + this.add_data.step1.occupational.q4.score

      this.add_data.step1.recreational.total_score = this.add_data.step1.recreational.q1.score
        + this.add_data.step1.recreational.q2.score

      this.add_data.step1.medical.total_score = this.add_data.step1.medical.q1.score
        + this.add_data.step1.medical.q2.score
        + this.add_data.step1.medical.q3.score
        + this.add_data.step1.medical.q4.score

      this.add_data.step1.total_score = this.add_data.step1.health_history.total_score
        + this.add_data.step1.occupational.total_score
        + this.add_data.step1.recreational.total_score
        + this.add_data.step1.medical.total_score
    },
    calculateStep2Score() {
      this.add_data.step2.alcohol.total_score = this.add_data.step2.alcohol.q1.score + 0

      this.add_data.step2.smoking.total_score = this.add_data.step2.smoking.q1.score + 0

      this.add_data.step2.nutrition.total_score = this.add_data.step2.nutrition.q1.score
        + this.add_data.step2.nutrition.q2.score

      this.add_data.step2.stress.total_score = this.add_data.step2.stress.q1.score
        + this.add_data.step2.stress.q2.score

      this.add_data.step2.sleep.total_score = this.add_data.step2.sleep.q1.score + 0

      this.add_data.step2.total_score = this.add_data.step2.alcohol.total_score
        + this.add_data.step2.smoking.total_score
        + this.add_data.step2.nutrition.total_score
        + this.add_data.step2.stress.total_score
        + this.add_data.step2.sleep.total_score
    },
    calculateStep3Score() {
      this.add_data.step3.body_composition.total_score = this.add_data.step3.body_composition.body_fat.score
        + this.add_data.step3.body_composition.bone_mass.score
        + this.add_data.step3.body_composition.visceral_fat.score
        + this.add_data.step3.body_composition.metabolic_body_age.score
        + this.add_data.step3.body_composition.height_waist_ratio.score

      this.add_data.step3.total_score = this.add_data.step3.blood_pressure_chart.score
        + this.add_data.step3.blood_bpd.score
        + this.add_data.step3.body_composition.total_score
    },
    calculateStep4Score() {
      this.add_data.step4.grid_postural_analysis.front_view_analysis.total_score = this.add_data.step4.grid_postural_analysis.front_view_analysis.q1.score
        + this.add_data.step4.grid_postural_analysis.front_view_analysis.q2.score
        + this.add_data.step4.grid_postural_analysis.front_view_analysis.q3.score
        + this.add_data.step4.grid_postural_analysis.front_view_analysis.q4.score
        + this.add_data.step4.grid_postural_analysis.front_view_analysis.q5.score

      this.add_data.step4.grid_postural_analysis.side_view_analysis.total_score = this.add_data.step4.grid_postural_analysis.side_view_analysis.q1.score
        + this.add_data.step4.grid_postural_analysis.side_view_analysis.q2.score
        + this.add_data.step4.grid_postural_analysis.side_view_analysis.q3.score
        + this.add_data.step4.grid_postural_analysis.side_view_analysis.q4.score
        + this.add_data.step4.grid_postural_analysis.side_view_analysis.q5.score

      this.add_data.step4.grid_postural_analysis.total_score = this.add_data.step4.grid_postural_analysis.front_view_analysis.total_score
        + this.add_data.step4.grid_postural_analysis.side_view_analysis.total_score

      this.add_data.step4.oc_cc.oc_test.total_score = this.add_data.step4.oc_cc.oc_test.q1.score
        + this.add_data.step4.oc_cc.oc_test.q2.score
        + this.add_data.step4.oc_cc.oc_test.q3.score
        + this.add_data.step4.oc_cc.oc_test.q4.score
        + this.add_data.step4.oc_cc.oc_test.q5.score

      this.add_data.step4.oc_cc.cc_test.total_score = this.add_data.step4.oc_cc.cc_test.q1.score
        + this.add_data.step4.oc_cc.cc_test.q2.score
        + this.add_data.step4.oc_cc.cc_test.q3.score
        + this.add_data.step4.oc_cc.cc_test.q4.score
        + this.add_data.step4.oc_cc.cc_test.q5.score

      this.add_data.step4.oc_cc.total_score = this.add_data.step4.oc_cc.oc_test.total_score
        + this.add_data.step4.oc_cc.cc_test.total_score

      this.add_data.step4.screening.total_score = this.add_data.step4.screening.deep_squat.score
        + this.add_data.step4.screening.hurdle_step.score
        + this.add_data.step4.screening.inline_lunge.score
        + this.add_data.step4.screening.shoulder_mobility.score
        + this.add_data.step4.screening.active_straight_leg_raise.score
        + this.add_data.step4.screening.trunk_stability_push_up.score
        + this.add_data.step4.screening.rotary_torso.score

      this.add_data.step4.physical.strength.score = Math.round(
        (this.add_data.step4.physical.strength.hand_hold.score
        + this.add_data.step4.physical.strength.push_up.score
        + this.add_data.step4.physical.strength.bodyweight_squat.score)/3
      )
      this.add_data.step4.physical.agility.score = this.add_data.step4.physical.agility.shark_test.score + 0

      this.add_data.step4.physical.score = this.add_data.step4.physical[this.add_data.step4.physical.default].score + 0

      this.add_data.step4.total_score = this.add_data.step4.grid_postural_analysis.total_score
        + this.add_data.step4.trx_map.score
        + this.add_data.step4.oc_cc.total_score
        + this.add_data.step4.screening.total_score
        + this.add_data.step4.physical.score
    },
    calculateTotalScore() {
      this.total_score = this.add_data.step1.total_score
        + this.add_data.step2.total_score
        + this.add_data.step3.total_score
        + this.add_data.step4.total_score

      this.calculateOverallScore()
    },
    calculateOverallScore() {
      this.overall_score = (this.total_score / 150 * 100) + '%'
    },
    fetchMemberData() {
      axios.get('fitness/v1/member/' + this.$route.query.member).then(response => {
        this.member_name = response.data.data.first_name + ' ' + response.data.data.last_name
        this.add_data.member_id = response.data.data.id
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchScoreSheet() {
      axios.get('crm/v1/member_pha/scoresheet').then(response => {
        this.scoresheet = response.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchDetail() {
      if(this.$route.query.id) {
        axios.get('crm/v1/member_pha/detail/'+this.$route.query.id).then(response => {
          this.add_data.id = response.data.data.id
          this.add_data.member_id = response.data.data.member_id

          this.add_data.step1.health_history.q1.score = response.data.data.step1_healthhistory_q1 ? response.data.data.step1_healthhistory_q1.score : null
          this.add_data.step1.health_history.q1.notes = response.data.data.step1_healthhistory_q1 ? response.data.data.step1_healthhistory_q1.notes : ''
          this.add_data.step1.health_history.q2.score = response.data.data.step1_healthhistory_q2 ? response.data.data.step1_healthhistory_q2.score : null
          this.add_data.step1.health_history.q2.notes = response.data.data.step1_healthhistory_q2 ? response.data.data.step1_healthhistory_q2.notes : ''
          this.add_data.step1.health_history.q3.score = response.data.data.step1_healthhistory_q3 ? response.data.data.step1_healthhistory_q3.score : null
          this.add_data.step1.health_history.q3.notes = response.data.data.step1_healthhistory_q3 ? response.data.data.step1_healthhistory_q3.notes : ''
          this.add_data.step1.health_history.q4.score = response.data.data.step1_healthhistory_q4 ? response.data.data.step1_healthhistory_q4.score : null
          this.add_data.step1.health_history.q4.notes = response.data.data.step1_healthhistory_q4 ? response.data.data.step1_healthhistory_q4.notes : ''
          this.add_data.step1.health_history.q5.score = response.data.data.step1_healthhistory_q5 ? response.data.data.step1_healthhistory_q5.score : null
          this.add_data.step1.health_history.q5.notes = response.data.data.step1_healthhistory_q5 ? response.data.data.step1_healthhistory_q5.notes : ''
          this.add_data.step1.health_history.q6.score = response.data.data.step1_healthhistory_q6 ? response.data.data.step1_healthhistory_q6.score : null
          this.add_data.step1.health_history.q6.notes = response.data.data.step1_healthhistory_q6 ? response.data.data.step1_healthhistory_q6.notes : ''
          this.add_data.step1.health_history.q7.score = response.data.data.step1_healthhistory_q7 ? response.data.data.step1_healthhistory_q7.score : null
          this.add_data.step1.health_history.q7.notes = response.data.data.step1_healthhistory_q7 ? response.data.data.step1_healthhistory_q7.notes : ''

          this.add_data.step1.occupational.current_occupation = response.data.data.current_occupation
          this.add_data.step1.occupational.q1.score = response.data.data.step1_occupational_q1 ? response.data.data.step1_occupational_q1.score : null
          this.add_data.step1.occupational.q1.notes = response.data.data.step1_occupational_q1 ? response.data.data.step1_occupational_q1.notes : ''
          this.add_data.step1.occupational.q2.score = response.data.data.step1_occupational_q2 ? response.data.data.step1_occupational_q2.score : null
          this.add_data.step1.occupational.q2.notes = response.data.data.step1_occupational_q2 ? response.data.data.step1_occupational_q2.notes : ''
          this.add_data.step1.occupational.q3.score = response.data.data.step1_occupational_q3 ? response.data.data.step1_occupational_q3.score : null
          this.add_data.step1.occupational.q3.notes = response.data.data.step1_occupational_q3 ? response.data.data.step1_occupational_q3.notes : ''
          this.add_data.step1.occupational.q4.score = response.data.data.step1_occupational_q4 ? response.data.data.step1_occupational_q4.score : null
          this.add_data.step1.occupational.q4.notes = response.data.data.step1_occupational_q4 ? response.data.data.step1_occupational_q4.notes : ''

          this.add_data.step1.recreational.q1.score = response.data.data.step1_recreational_q1 ? response.data.data.step1_recreational_q1.score : null
          this.add_data.step1.recreational.q1.notes = response.data.data.step1_recreational_q1 ? response.data.data.step1_recreational_q1.notes : ''
          this.add_data.step1.recreational.q2.score = response.data.data.step1_recreational_q2 ? response.data.data.step1_recreational_q2.score : null
          this.add_data.step1.recreational.q2.notes = response.data.data.step1_recreational_q2 ? response.data.data.step1_recreational_q2.notes : ''

          this.add_data.step1.medical.q1.score = response.data.data.step1_medical_q1 ? response.data.data.step1_medical_q1.score : null
          this.add_data.step1.medical.q1.notes = response.data.data.step1_medical_q1 ? response.data.data.step1_medical_q1.notes : ''
          this.add_data.step1.medical.q2.score = response.data.data.step1_medical_q2 ? response.data.data.step1_medical_q2.score : null
          this.add_data.step1.medical.q2.notes = response.data.data.step1_medical_q2 ? response.data.data.step1_medical_q2.notes : ''
          this.add_data.step1.medical.q3.score = response.data.data.step1_medical_q3 ? response.data.data.step1_medical_q3.score : null
          this.add_data.step1.medical.q3.notes = response.data.data.step1_medical_q3 ? response.data.data.step1_medical_q3.notes : ''
          this.add_data.step1.medical.q4.score = response.data.data.step1_medical_q4 ? response.data.data.step1_medical_q4.score : null
          this.add_data.step1.medical.q4.notes = response.data.data.step1_medical_q4 ? response.data.data.step1_medical_q4.notes : ''

          this.add_data.step2.alcohol.q1.score = response.data.data.step2_alcohol_q1 ? response.data.data.step2_alcohol_q1.score : null
          this.add_data.step2.alcohol.q1.notes = response.data.data.step2_alcohol_q1 ? response.data.data.step2_alcohol_q1.notes : ''
          this.add_data.step2.smoking.q1.score = response.data.data.step2_smoking_q1 ? response.data.data.step2_smoking_q1.score : null
          this.add_data.step2.smoking.q1.notes = response.data.data.step2_smoking_q1 ? response.data.data.step2_smoking_q1.notes : ''
          this.add_data.step2.nutrition.q1.score = response.data.data.step2_nutrition_q1 ? response.data.data.step2_nutrition_q1.score : null
          this.add_data.step2.nutrition.q1.notes = response.data.data.step2_nutrition_q1 ? response.data.data.step2_nutrition_q1.notes : ''
          this.add_data.step2.nutrition.q2.score = response.data.data.step2_nutrition_q2 ? response.data.data.step2_nutrition_q2.score : null
          this.add_data.step2.nutrition.q2.notes = response.data.data.step2_nutrition_q2 ? response.data.data.step2_nutrition_q2.notes : ''
          this.add_data.step2.stress.q1.score = response.data.data.step2_stress_q1 ? response.data.data.step2_stress_q1.score : null
          this.add_data.step2.stress.q1.notes = response.data.data.step2_stress_q1 ? response.data.data.step2_stress_q1.notes : ''
          this.add_data.step2.stress.q2.score = response.data.data.step2_stress_q2 ? response.data.data.step2_stress_q2.score : null
          this.add_data.step2.stress.q2.notes = response.data.data.step2_stress_q2 ? response.data.data.step2_stress_q2.notes : ''
          this.add_data.step2.sleep.q1.score = response.data.data.step2_sleep_q1 ? response.data.data.step2_sleep_q1.score : null
          this.add_data.step2.sleep.q1.notes = response.data.data.step2_sleep_q1 ? response.data.data.step2_sleep_q1.notes : ''

          this.add_data.step3.blood_pressure_chart.systolic = response.data.data.step3_blood_pressure_chart ? response.data.data.step3_blood_pressure_chart.systolic : null
          this.add_data.step3.blood_pressure_chart.diastolic = response.data.data.step3_blood_pressure_chart ? response.data.data.step3_blood_pressure_chart.diastolic : null
          this.add_data.step3.blood_pressure_chart.score = response.data.data.step3_blood_pressure_chart ? response.data.data.step3_blood_pressure_chart.score : 0
          this.add_data.step3.blood_bpd.value = response.data.data.step3_blood_bpd ? response.data.data.step3_blood_bpd.value : ''
          this.add_data.step3.blood_bpd.score = response.data.data.step3_blood_bpd ? response.data.data.step3_blood_bpd.score : 0

          this.add_data.step3.body_composition.body_fat.value = response.data.data.step3_body_fat ? response.data.data.step3_body_fat.value : ''
          this.add_data.step3.body_composition.body_fat.score = response.data.data.step3_body_fat ? response.data.data.step3_body_fat.score : 0
          this.add_data.step3.body_composition.bone_mass.value = response.data.data.step3_bone_mass ? response.data.data.step3_bone_mass.value : ''
          this.add_data.step3.body_composition.bone_mass.score = response.data.data.step3_bone_mass ? response.data.data.step3_bone_mass.score : 0
          this.add_data.step3.body_composition.visceral_fat.value = response.data.data.step3_visceral_fat ? response.data.data.step3_visceral_fat.value : ''
          this.add_data.step3.body_composition.visceral_fat.score = response.data.data.step3_visceral_fat ? response.data.data.step3_visceral_fat.score : null
          this.add_data.step3.body_composition.metabolic_body_age.value = response.data.data.step3_metabolic_body_age ? response.data.data.step3_metabolic_body_age.value : ''
          this.add_data.step3.body_composition.metabolic_body_age.score = response.data.data.step3_metabolic_body_age ? response.data.data.step3_metabolic_body_age.score : 0
          this.add_data.step3.bmi = response.data.data.step3_bmi
          this.add_data.step3.body_composition.bmi = response.data.data.step3_bmi
          this.add_data.step3.body_composition.height_waist_ratio.score = response.data.data.step3_height_waist_ratio ? response.data.data.step3_height_waist_ratio.score : 0

          this.add_data.step3.gender = response.data.data.step3_gender ? response.data.data.step3_gender : 'male'
          this.add_data.step3.age = response.data.data.step3_age ? response.data.data.step3_age : null
          this.add_data.step3.height = response.data.data.step3_height ? response.data.data.step3_height : null
          this.add_data.step3.weight = response.data.data.step3_weight ? response.data.data.step3_weight : null
          this.add_data.step3.waist = response.data.data.step3_waist ? response.data.data.step3_waist : null

          this.add_data.step4.grid_postural_analysis.img1 = response.data.data.step4_image1 ? response.data.data.step4_image1 : ''
          this.add_data.step4.grid_postural_analysis.img2 = response.data.data.step4_image2 ? response.data.data.step4_image2 : ''
          this.add_data.step4.grid_postural_analysis.img3 = response.data.data.step4_image3 ? response.data.data.step4_image3 : ''
          this.image_data1 = response.data.data.step4_image1 ? Auth.apiUrl + 'crm/v1/img/pha/' + response.data.data.step4_image1 : ''
          this.image_data2 = response.data.data.step4_image2 ? Auth.apiUrl + 'crm/v1/img/pha/' + response.data.data.step4_image2 : ''
          this.image_data3 = response.data.data.step4_image3 ? Auth.apiUrl + 'crm/v1/img/pha/' + response.data.data.step4_image3 : ''

          this.add_data.step4.grid_postural_analysis.front_view_analysis.q1.score = response.data.data.step4_front_view_analysis_q1 ? response.data.data.step4_front_view_analysis_q1.score : 0
          this.add_data.step4.grid_postural_analysis.front_view_analysis.q2.score = response.data.data.step4_front_view_analysis_q2 ? response.data.data.step4_front_view_analysis_q2.score : 0
          this.add_data.step4.grid_postural_analysis.front_view_analysis.q3.score = response.data.data.step4_front_view_analysis_q3 ? response.data.data.step4_front_view_analysis_q3.score : 0
          this.add_data.step4.grid_postural_analysis.front_view_analysis.q4.score = response.data.data.step4_front_view_analysis_q4 ? response.data.data.step4_front_view_analysis_q4.score : 0
          this.add_data.step4.grid_postural_analysis.front_view_analysis.q5.score = response.data.data.step4_front_view_analysis_q5 ? response.data.data.step4_front_view_analysis_q5.score : 0

          this.add_data.step4.grid_postural_analysis.side_view_analysis.q1.score = response.data.data.step4_side_view_analysis_q1 ? response.data.data.step4_side_view_analysis_q1.score : 0
          this.add_data.step4.grid_postural_analysis.side_view_analysis.q2.score = response.data.data.step4_side_view_analysis_q2 ? response.data.data.step4_side_view_analysis_q2.score : 0
          this.add_data.step4.grid_postural_analysis.side_view_analysis.q3.score = response.data.data.step4_side_view_analysis_q3 ? response.data.data.step4_side_view_analysis_q3.score : 0
          this.add_data.step4.grid_postural_analysis.side_view_analysis.q4.score = response.data.data.step4_side_view_analysis_q4 ? response.data.data.step4_side_view_analysis_q4.score : 0
          this.add_data.step4.grid_postural_analysis.side_view_analysis.q5.score = response.data.data.step4_side_view_analysis_q5 ? response.data.data.step4_side_view_analysis_q5.score : 0

          this.add_data.step4.trx_map.value = response.data.data.step4_trx_map ? response.data.data.step4_trx_map.value : ''
          this.add_data.step4.trx_map.score = response.data.data.step4_trx_map ? response.data.data.step4_trx_map.score : null

          this.add_data.step4.oc_cc.oc_test.q1.score = response.data.data.step4_oc_test_q1 ? response.data.data.step4_oc_test_q1.score : 0
          this.add_data.step4.oc_cc.oc_test.q2.score = response.data.data.step4_oc_test_q2 ? response.data.data.step4_oc_test_q2.score : 0
          this.add_data.step4.oc_cc.oc_test.q3.score = response.data.data.step4_oc_test_q3 ? response.data.data.step4_oc_test_q3.score : 0
          this.add_data.step4.oc_cc.oc_test.q4.score = response.data.data.step4_oc_test_q4 ? response.data.data.step4_oc_test_q4.score : 0
          this.add_data.step4.oc_cc.oc_test.q5.score = response.data.data.step4_oc_test_q5 ? response.data.data.step4_oc_test_q5.score : 0
          this.add_data.step4.oc_cc.cc_test.q1.score = response.data.data.step4_cc_test_q1 ? response.data.data.step4_cc_test_q1.score : 0
          this.add_data.step4.oc_cc.cc_test.q2.score = response.data.data.step4_cc_test_q2 ? response.data.data.step4_cc_test_q2.score : 0
          this.add_data.step4.oc_cc.cc_test.q3.score = response.data.data.step4_cc_test_q3 ? response.data.data.step4_cc_test_q3.score : 0
          this.add_data.step4.oc_cc.cc_test.q4.score = response.data.data.step4_cc_test_q4 ? response.data.data.step4_cc_test_q4.score : 0
          this.add_data.step4.oc_cc.cc_test.q5.score = response.data.data.step4_cc_test_q5 ? response.data.data.step4_cc_test_q5.score : 0

          this.add_data.step4.screening.deep_squat.score = response.data.data.step4_screening_deep_squat ? response.data.data.step4_screening_deep_squat.score : null
          this.add_data.step4.screening.deep_squat.notes = response.data.data.step4_screening_deep_squat ? response.data.data.step4_screening_deep_squat.notes : ''
          this.add_data.step4.screening.hurdle_step.score = response.data.data.step4_screening_hurdle_step ? response.data.data.step4_screening_hurdle_step.score : null
          this.add_data.step4.screening.hurdle_step.notes = response.data.data.step4_screening_hurdle_step ? response.data.data.step4_screening_hurdle_step.notes : ''
          this.add_data.step4.screening.inline_lunge.score = response.data.data.step4_screening_inline_lunge ? response.data.data.step4_screening_inline_lunge.score : null
          this.add_data.step4.screening.inline_lunge.notes = response.data.data.step4_screening_inline_lunge ? response.data.data.step4_screening_inline_lunge.notes : ''
          this.add_data.step4.screening.shoulder_mobility.score = response.data.data.step4_screening_shoulder_mobility ? response.data.data.step4_screening_shoulder_mobility.score : null
          this.add_data.step4.screening.shoulder_mobility.notes = response.data.data.step4_screening_shoulder_mobility ? response.data.data.step4_screening_shoulder_mobility.notes : ''
          this.add_data.step4.screening.active_straight_leg_raise.score = response.data.data.step4_screening_active_straight_leg_raise ? response.data.data.step4_screening_active_straight_leg_raise.score : null
          this.add_data.step4.screening.active_straight_leg_raise.notes = response.data.data.step4_screening_active_straight_leg_raise ? response.data.data.step4_screening_active_straight_leg_raise.notes : ''
          this.add_data.step4.screening.trunk_stability_push_up.score = response.data.data.step4_screening_trunk_stability_push_up ? response.data.data.step4_screening_trunk_stability_push_up.score : null
          this.add_data.step4.screening.trunk_stability_push_up.notes = response.data.data.step4_screening_trunk_stability_push_up ? response.data.data.step4_screening_trunk_stability_push_up.notes : ''
          this.add_data.step4.screening.rotary_torso.score = response.data.data.step4_screening_rotary_torso ? response.data.data.step4_screening_rotary_torso.score : null
          this.add_data.step4.screening.rotary_torso.notes = response.data.data.step4_screening_rotary_torso ? response.data.data.step4_screening_rotary_torso.notes : ''

          this.add_data.step4.physical.default = response.data.data.step4_physical_default ? response.data.data.step4_physical_default : null
          this.add_data.step4.physical.vo2_max.value = response.data.data.step4_vo2_max ? response.data.data.step4_vo2_max.value : null
          this.add_data.step4.physical.vo2_max.score = response.data.data.step4_vo2_max ? response.data.data.step4_vo2_max.score : null
          this.add_data.step4.physical.strength.hand_hold.value = response.data.data.step4_strength_hand_hold ? response.data.data.step4_strength_hand_hold.value : null
          this.add_data.step4.physical.strength.hand_hold.score = response.data.data.step4_strength_hand_hold ? response.data.data.step4_strength_hand_hold.score : null
          this.add_data.step4.physical.strength.push_up.value = response.data.data.step4_strength_push_up ? response.data.data.step4_strength_push_up.value : null
          this.add_data.step4.physical.strength.push_up.score = response.data.data.step4_strength_push_up ? response.data.data.step4_strength_push_up.score : null
          this.add_data.step4.physical.strength.bodyweight_squat.value = response.data.data.step4_strength_bodyweight_squat ? response.data.data.step4_strength_bodyweight_squat.value : null
          this.add_data.step4.physical.strength.bodyweight_squat.score = response.data.data.step4_strength_bodyweight_squat ? response.data.data.step4_strength_bodyweight_squat.score : null

          this.add_data.step4.physical.agility.shark_test.value = response.data.data.step4_agility_shark_test ? response.data.data.step4_agility_shark_test.value : null
          this.add_data.step4.physical.agility.shark_test.score = response.data.data.step4_agility_shark_test ? response.data.data.step4_agility_shark_test.score : null

          this.calculateBloodPressure()
          this.calculateBoneMassPercent()
          this.calculateMetabolicAgeDiff()
          this.calculateHeightWaistRatio()
          this.calculateVo2max()

          this.calculateStep1Score()
          this.calculateStep2Score()
          this.calculateStep3Score()
          this.calculateStep4Score()
          this.calculateTotalScore()
          this.calculateOverallScore()
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    submitStep(step, group) {
      if(this.$validator.validateAll()) {
        let data
        if(step != 4) {
          data = this.add_data['step'+step]
          data.id = this.add_data.id
          data.member_id = this.add_data.member_id
          data.step = step
          data.group = group
        } else {
          if(group == 'grid_postural_analysis') {
            axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
            data = new FormData()
            data.append('id', this.add_data.id)
            data.append('member_id', this.add_data.member_id)
            data.append('step', step)
            data.append('group', group)
            data.append('total_score', this.add_data.step4.total_score)
            data.append('gender', this.add_data.step3.gender.toLowerCase())

            data.append('front_view_analysis', JSON.stringify(this.add_data.step4.grid_postural_analysis.front_view_analysis))
            data.append('side_view_analysis', JSON.stringify(this.add_data.step4.grid_postural_analysis.side_view_analysis))
            if(this.add_data.step4.grid_postural_analysis.img1)
              data.append('step4_image1', this.add_data.step4.grid_postural_analysis.img1)
            if(this.add_data.step4.grid_postural_analysis.img2)
              data.append('step4_image2', this.add_data.step4.grid_postural_analysis.img2)
            if(this.add_data.step4.grid_postural_analysis.img3)
              data.append('step4_image3', this.add_data.step4.grid_postural_analysis.img3)
          } else {
            data = this.add_data.step4
            data.id = this.add_data.id
            data.member_id = this.add_data.member_id
            data.step = step
            data.group = group
            data.gender = this.add_data.step3.gender.toLowerCase()
          }
        }

        // update running session
        if (step == 1 || step == 2 || step == 3) {
          const jsonData = {
            personal_trainer_id: Auth.Session.get().paradigm_id,
            member_id: this.$route.query.member
          }
          axios.post("fitness/v1/member_pt_session/update_running_session_member_pha", jsonData).then((res) => {
            console.log("Member Running Session Updated...")
          }).catch(error => {console.log('error', error)})
        }

        // console.log('all data', data)

        axios.post('crm/v1/member_pha/', data).then(response => {
          // console.log('test', response)
          this.add_data.id = response.data.data.id
          this.$toast.success('data saved successfully!', 'Success', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }).catch(error => {
          console.log('error', error)
        })
      }
    }
  },
  computed: {
    healthHistoryQ1Score() { return this.add_data.step1.health_history.q1.score },
    healthHistoryQ2Score() { return this.add_data.step1.health_history.q2.score },
    healthHistoryQ3Score() { return this.add_data.step1.health_history.q3.score },
    healthHistoryQ4Score() { return this.add_data.step1.health_history.q4.score },
    healthHistoryQ5Score() { return this.add_data.step1.health_history.q5.score },
    healthHistoryQ6Score() { return this.add_data.step1.health_history.q6.score },
    healthHistoryQ7Score() { return this.add_data.step1.health_history.q7.score },

    occupationalQ1Score() { return this.add_data.step1.occupational.q1.score },
    occupationalQ2Score() { return this.add_data.step1.occupational.q2.score },
    occupationalQ3Score() { return this.add_data.step1.occupational.q3.score },
    occupationalQ4Score() { return this.add_data.step1.occupational.q4.score },

    recreationalQ1Score() { return this.add_data.step1.recreational.q1.score },
    recreationalQ2Score() { return this.add_data.step1.recreational.q2.score },

    medicalQ1Score() { return this.add_data.step1.medical.q1.score },
    medicalQ2Score() { return this.add_data.step1.medical.q2.score },
    medicalQ3Score() { return this.add_data.step1.medical.q3.score },
    medicalQ4Score() { return this.add_data.step1.medical.q4.score },

    alcoholQ1Score() { return this.add_data.step2.alcohol.q1.score ? this.add_data.step2.alcohol.q1.score : 0 },
    smokingQ1Score() { return this.add_data.step2.smoking.q1.score },
    nutritionQ1Score() { return this.add_data.step2.nutrition.q1.score },
    nutritionQ2Score() { return this.add_data.step2.nutrition.q2.score },
    stressQ1Score() { return this.add_data.step2.stress.q1.score },
    stressQ2Score() { return this.add_data.step2.stress.q2.score },
    sleepQ1Score() { return this.add_data.step2.sleep.q1.score },

    bloodPressureChartScore() { return this.add_data.step3.blood_pressure_chart.score },
    bloodBpdScore() { return this.add_data.step3.blood_bpd.score },
    bodyFatScore() { return this.add_data.step3.body_composition.body_fat.score },
    boneMassScore() { return this.add_data.step3.body_composition.bone_mass.score },
    visceralFatScore() { return this.add_data.step3.body_composition.visceral_fat.score },
    metabolicBodyAgeScore() { return this.add_data.step3.body_composition.metabolic_body_age.score },
    heightWaistRatioScore() { return this.add_data.step3.body_composition.height_waist_ratio.score },

    frontViewAnalysisQ1Score() { return this.add_data.step4.grid_postural_analysis.front_view_analysis.q1.score ? this.add_data.step4.grid_postural_analysis.front_view_analysis.q1.score : 0 },
    frontViewAnalysisQ2Score() { return this.add_data.step4.grid_postural_analysis.front_view_analysis.q2.score ? this.add_data.step4.grid_postural_analysis.front_view_analysis.q2.score : 0 },
    frontViewAnalysisQ3Score() { return this.add_data.step4.grid_postural_analysis.front_view_analysis.q3.score ? this.add_data.step4.grid_postural_analysis.front_view_analysis.q3.score : 0 },
    frontViewAnalysisQ4Score() { return this.add_data.step4.grid_postural_analysis.front_view_analysis.q4.score ? this.add_data.step4.grid_postural_analysis.front_view_analysis.q4.score : 0 },
    frontViewAnalysisQ5Score() { return this.add_data.step4.grid_postural_analysis.front_view_analysis.q5.score ? this.add_data.step4.grid_postural_analysis.front_view_analysis.q5.score : 0 },

    sideViewAnalysisQ1Score() { return this.add_data.step4.grid_postural_analysis.side_view_analysis.q1.score ? this.add_data.step4.grid_postural_analysis.side_view_analysis.q1.score : 0 },
    sideViewAnalysisQ2Score() { return this.add_data.step4.grid_postural_analysis.side_view_analysis.q2.score ? this.add_data.step4.grid_postural_analysis.side_view_analysis.q2.score : 0 },
    sideViewAnalysisQ3Score() { return this.add_data.step4.grid_postural_analysis.side_view_analysis.q3.score ? this.add_data.step4.grid_postural_analysis.side_view_analysis.q3.score : 0 },
    sideViewAnalysisQ4Score() { return this.add_data.step4.grid_postural_analysis.side_view_analysis.q4.score ? this.add_data.step4.grid_postural_analysis.side_view_analysis.q4.score : 0 },
    sideViewAnalysisQ5Score() { return this.add_data.step4.grid_postural_analysis.side_view_analysis.q5.score ? this.add_data.step4.grid_postural_analysis.side_view_analysis.q5.score : 0 },

    trxMapScore() { return this.add_data.step4.trx_map.score ? this.add_data.step4.trx_map.score : 0 },

    ocTestQ1Score() { return this.add_data.step4.oc_cc.oc_test.q1.score ? this.add_data.step4.oc_cc.oc_test.q1.score : 0 },
    ocTestQ2Score() { return this.add_data.step4.oc_cc.oc_test.q2.score ? this.add_data.step4.oc_cc.oc_test.q2.score : 0 },
    ocTestQ3Score() { return this.add_data.step4.oc_cc.oc_test.q3.score ? this.add_data.step4.oc_cc.oc_test.q3.score : 0 },
    ocTestQ4Score() { return this.add_data.step4.oc_cc.oc_test.q4.score ? this.add_data.step4.oc_cc.oc_test.q4.score : 0 },
    ocTestQ5Score() { return this.add_data.step4.oc_cc.oc_test.q5.score ? this.add_data.step4.oc_cc.oc_test.q5.score : 0 },

    ccTestQ1Score() { return this.add_data.step4.oc_cc.cc_test.q1.score ? this.add_data.step4.oc_cc.cc_test.q1.score : 0 },
    ccTestQ2Score() { return this.add_data.step4.oc_cc.cc_test.q2.score ? this.add_data.step4.oc_cc.cc_test.q2.score : 0 },
    ccTestQ3Score() { return this.add_data.step4.oc_cc.cc_test.q3.score ? this.add_data.step4.oc_cc.cc_test.q3.score : 0 },
    ccTestQ4Score() { return this.add_data.step4.oc_cc.cc_test.q4.score ? this.add_data.step4.oc_cc.cc_test.q4.score : 0 },
    ccTestQ5Score() { return this.add_data.step4.oc_cc.cc_test.q5.score ? this.add_data.step4.oc_cc.cc_test.q5.score : 0 },

    deepSquatScore() { return this.add_data.step4.screening.deep_squat.score ? this.add_data.step4.screening.deep_squat.score : 0 },
    hurdleStepScore() { return this.add_data.step4.screening.hurdle_step.score ? this.add_data.step4.screening.hurdle_step.score : 0 },
    inlineLungeScore() { return this.add_data.step4.screening.inline_lunge.score ? this.add_data.step4.screening.inline_lunge.score : 0 },
    shoulderMobilityScore() { return this.add_data.step4.screening.shoulder_mobility.score ? this.add_data.step4.screening.shoulder_mobility.score : 0 },
    activeStraightLegRaiseScore() { return this.add_data.step4.screening.active_straight_leg_raise.score ? this.add_data.step4.screening.active_straight_leg_raise.score : 0 },
    trunkStabilityPushUpScore() { return this.add_data.step4.screening.trunk_stability_push_up.score ? this.add_data.step4.screening.trunk_stability_push_up.score : 0 },
    rotaryTorsoScore() { return this.add_data.step4.screening.rotary_torso.score ? this.add_data.step4.screening.rotary_torso.score : 0 },

    vo2MaxScore() { return this.add_data.step4.physical.vo2_max.score ? this.add_data.step4.physical.vo2_max.score : 0 },
    physicalDefault() { return this.add_data.step4.physical.default ? this.add_data.step4.physical.default : null },
    handHoldScore() { return this.add_data.step4.physical.strength.hand_hold.score ? this.add_data.step4.physical.strength.hand_hold.score : 0 },
    pushUpScore() { return this.add_data.step4.physical.strength.push_up.score ? this.add_data.step4.physical.strength.push_up.score : 0 },
    bodyweightSquatScore() { return this.add_data.step4.physical.strength.bodyweight_squat.score ? this.add_data.step4.physical.strength.bodyweight_squat.score : 0 },
    sharkTestScore() { return this.add_data.step4.physical.agility.shark_test.score ? this.add_data.step4.physical.agility.shark_test.score : 0 }
  },
  watch: {
    healthHistoryQ1Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ2Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ3Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ4Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ5Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ6Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    healthHistoryQ7Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },

    occupationalQ1Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    occupationalQ2Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    occupationalQ3Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    occupationalQ4Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },

    recreationalQ1Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    recreationalQ2Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },

    medicalQ1Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    medicalQ2Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    medicalQ3Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },
    medicalQ4Score() {
      this.calculateStep1Score()
      this.calculateTotalScore()
    },

    alcoholQ1Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    smokingQ1Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    nutritionQ1Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    nutritionQ2Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    stressQ1Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    stressQ2Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },
    sleepQ1Score() {
      this.calculateStep2Score()
      this.calculateTotalScore()
    },

    bloodPressureChartScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    bloodBpdScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    bodyFatScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    boneMassScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    visceralFatScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    metabolicBodyAgeScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },
    heightWaistRatioScore() {
      this.calculateStep3Score()
      this.calculateTotalScore()
    },

    frontViewAnalysisQ1Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    frontViewAnalysisQ2Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    frontViewAnalysisQ3Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    frontViewAnalysisQ4Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    frontViewAnalysisQ5Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    sideViewAnalysisQ1Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    sideViewAnalysisQ2Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    sideViewAnalysisQ3Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    sideViewAnalysisQ4Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    sideViewAnalysisQ5Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    trxMapScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    ocTestQ1Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ocTestQ2Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ocTestQ3Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ocTestQ4Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ocTestQ5Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    ccTestQ1Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ccTestQ2Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ccTestQ3Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ccTestQ4Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    ccTestQ5Score() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    deepSquatScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    hurdleStepScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    inlineLungeScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    shoulderMobilityScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    activeStraightLegRaiseScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    trunkStabilityPushUpScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    rotaryTorsoScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },

    vo2MaxScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    physicalDefault() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    handHoldScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    pushUpScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    bodyweightSquatScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    },
    sharkTestScore() {
      this.calculateStep4Score()
      this.calculateTotalScore()
    }
  },
  created () {
    this.fetchMemberData()
    this.fetchScoreSheet()
    this.fetchDetail()
  }
}
</script>
